module.exports = __webpack_public_path__ + "img/agenda_details.aed18b77.svg";